const NAVBAR_MENU = [
  {
    route: "/",
    label: "Home",
    show: true,
  },
  {
    route: "/mini-case-competition",
    label: "Mini Case Competition",
    show: true,
  },
  {
    route: "/company-visit",
    label: "Company Visit",
    show: true,
  },
  {
    route: "/job-expo",
    label: "Job Expo",
    show: true,
  },
  {
    route: "/seminar",
    label: "Seminar",
    show: true,
  },
  {
    route: "/about-us",
    label: "About Us",
    show: true,
  },
];

export default NAVBAR_MENU;
